import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {ClientRequestForm} from "../../../../types/interfaces";
import {PreloaderService} from "../../../../services/preloader/preloader.service";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";
import {AlertService} from "../../../../services/alert/alert.service";


declare var EXIF: any;

@Component({
    selector: 'app-edit-child-photo',
    templateUrl: './edit-child-photo.component.html',
    styleUrls: ['./edit-child-photo.component.scss'],
})
export class EditChildPhotoComponent implements OnInit {


    @Input() childId: number = 0;
    @Input() open: boolean = false;


    attachingImage: boolean = false;
    attachedImageData: string[] = []
    @Input() selectedImageBase: string | undefined | null = undefined;
   selectedImage: string | undefined | null = undefined;

    childIcon: string = '';

    availableIcons: any[] = [
        {value: 'boy', image: 'assets/images/child/boy.png'},
        {value: 'girl', image: 'assets/images/child/girl.png'}
    ];

    constructor(private modalCtrl: ModalController,
                private preloaderService: PreloaderService,
                public myGcService: MyGreenCountry,
                public alertService: AlertService,) {
    }

    ngOnInit() {
        this. selectedImage = this.selectedImageBase;
    }

    showSaveBtn(){
        return (this.selectedImage != this.selectedImageBase) || (this.selectedImage === null && this.selectedImageBase !=null);
    }

    choseIcon(icon: string) {
        this.childIcon = icon;

    }

    downloadPhoto() {

    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    triggerFileInput() {

        const fileInput = document.getElementById('fileInput') as HTMLInputElement;
        fileInput.click();
    }


    async onFileSelected(event: any) {
        let file = event.target.files[0];
        let max_size = 400;
        this.attachingImage = true;

        if (!file) return;

        let dataUrl = await this.resizeImage(file, max_size);

        this.attachingImage = false;
        this.attachedImageData.push(dataUrl);

        this.selectedImage = dataUrl;
    }

    discharge() {
        this.selectedImage = null;
        this.attachedImageData = [];

        let fileInput = document.getElementById('fileInput') as HTMLInputElement;
        fileInput.value = '';
    }


    base64ToFile(base64String: string, filename: string): File | null {
        if (!base64String.startsWith('data:')) {
            console.error('Invalid base64 string');
            return null;
        }

        const arr = base64String.split(',');
        const mime = arr[0].match(/:(.*?);/);

        if (!mime) {
            console.error('MIME type not found');
            return null;
        }

        const mimeType = mime[1];
        const bstr = atob(arr[1]);
        const n = bstr.length;
        const u8arr = new Uint8Array(n);

        for (let i = 0; i < n; i++) {
            u8arr[i] = bstr.charCodeAt(i);
        }

        return new File([u8arr], filename, {type: mimeType});
    }


    async updateAvatar() {
        if (this.selectedImage) {
            let file = this.base64ToFile(this.selectedImage, 'avatar')

            if (file) {
                await this.preloaderService.showLoading("Зачекайте, будь ласка");
                this.myGcService.updateAvatar(file)
                    .subscribe({
                        next: (response) => {
                            if (response.success) {
                                this.discharge();
                                this.closeAndReload();
                            }

                        },
                        error: (error) => {
                            this.preloaderService.hideLoading();
                            let message = 'Oops! Something went wrong';

                            if (error.status === 422) {
                                message =
                                    error.error.message ?? 'Oops! Something went wrong'
                            }

                            this.alertService.presentAlert(
                                message,
                                '',
                                [{text: 'ok',}]);

                        },
                        complete: () => {
                            this.preloaderService.hideLoading();
                        }
                    })

            }

        }else if (this.selectedImage === null){
            await this.preloaderService.showLoading("Зачекайте, будь ласка");
            this.myGcService.deleteAvatar()
                .subscribe({
                    next: (response) => {
                        if (response.success) {
                            this.discharge();
                            this.closeAndReload();
                        }

                    },
                    error: (error) => {
                        this.preloaderService.hideLoading();
                        let message = 'Oops! Something went wrong';

                        if (error.status === 422) {
                            message =
                                error.error.message ?? 'Oops! Something went wrong'
                        }

                        this.alertService.presentAlert(
                            message,
                            '',
                            [{text: 'ok',}]);

                    },
                    complete: () => {
                        this.preloaderService.hideLoading();
                    }
                })
        }
    }


    async resizeImage(file: File, maxSize: number): Promise<string> {
        return new Promise((resolve) => {
            const reader = new FileReader();

            reader.onload = (readerEvent: any) => {
                const image = new Image();

                image.onload = async () => {
                    const orientation = await this.getOrientation(image);
                    const {width, height} = this.calculateAspectRatio(image, maxSize);
                    const canvas = this.getCanvasWithOrientation(orientation, width, height);

                    canvas.getContext('2d')?.drawImage(image, 0, 0, width, height);

                    const dataUrl = canvas.toDataURL(file.type);
                    resolve(dataUrl);
                };
                if (readerEvent.target.result) {
                    image.src = readerEvent.target.result;
                }
            };
            reader.readAsDataURL(file);
        });
    }

    calculateAspectRatio(image: HTMLImageElement, maxSize: number) {
        let {width, height} = image;
        if (width > height && width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
        } else if (height > width && height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
        }
        return {width, height};
    }


    async getOrientation(image: HTMLImageElement): Promise<number> {
        return new Promise((resolve) => {
            EXIF.getDataFromDataURL(image, (exifData: any) => {
                resolve(exifData.Orientation || 1);
            });
        });
    }


    getCanvasWithOrientation(orientation: number, width: number, height: number): HTMLCanvasElement {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        switch (orientation) {
            case 5:
            case 6:
            case 7:
            case 8:
                canvas.width = height;
                canvas.height = width;
                break;
            default:
                canvas.width = width;
                canvas.height = height;
        }

        if (ctx) {
            switch (orientation) {
                case 2: // horizontal flip
                    ctx.translate(width, 0);
                    ctx.scale(-1, 1);
                    break;
                case 3: // 180 rotate left
                    ctx.translate(width, height);
                    ctx.rotate(Math.PI);
                    break;
                case 4: // vertical flip
                    ctx.translate(0, height);
                    ctx.scale(1, -1);
                    break;
                case 5: // vertical flip + 90 rotate right
                    ctx.rotate(0.5 * Math.PI);
                    ctx.scale(1, -1);
                    break;
                case 6: // 90 rotate right
                    ctx.rotate(0.5 * Math.PI);
                    ctx.translate(0, -height);
                    break;
                case 7: // horizontal flip + 90 rotate right
                    ctx.rotate(0.5 * Math.PI);
                    ctx.translate(width, -height);
                    ctx.scale(-1, 1);
                    break;
                case 8: // 90 rotate left
                    ctx.rotate(-0.5 * Math.PI);
                    ctx.translate(-width, 0);
                    break;
            }
        }

        return canvas;
    }

    closeAndReload() {
        return this.modalCtrl.dismiss(null, 'reload');
    }
}
